import React from 'react'
import PropTypes from 'prop-types'
import { Text, Margin, Link } from 'shared/components'
import { main } from 'routes/route.map'
import BalanceAccess from 'routes/shared/layout/components/header/components/balanceAccess'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { NavLink } from 'react-router-dom'
import * as styles from './styles'

const currentYear = new Date().getFullYear()

const MenuWrapper = ({ children, isOpen, backButtonLink = '' }) => (
  <div css={styles.menuWrapper} style={{ display: isOpen ? 'flex' : '' }}>
    <div>
      <Link css={styles.heading} to={main}>
        <img
          src="./img/logoType.png"
          height={30}
          style={{ marginBottom: '8px' }}
          alt="logo"
        />
        <Text size={18} css={styles.branding}>
          Influence. Win!
        </Text>
      </Link>
      <div css={styles.mobileMenuBalance}>
        <BalanceAccess isVisible={true} displayInwins={true} />
      </div>
      <menu css={styles.menuList}>
        {backButtonLink && (
          <Margin left={5} bottom={5}>
            <NavLink exact to={backButtonLink} css={styles.linkBack}>
              <div>
                <Margin
                  as={FontAwesomeIcon}
                  right={1}
                  size="lg"
                  icon={'caret-left'}
                />
                <Text size={11}>Back</Text>
              </div>
            </NavLink>
          </Margin>
        )}
        <Margin left={5}>
          <Text css={styles.menuTitle}>MAIN MENU</Text>
        </Margin>
        {children}
      </menu>
    </div>
    <div css={styles.copyright}>
      © {currentYear} Inwin Corporation. All rights reserved.
    </div>
  </div>
)

MenuWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  isOpen: PropTypes.bool,
  backButtonLink: PropTypes.string,
}

export default MenuWrapper
